import { ChatWorkspace } from "@/components/chat/chat-workspace";
import { Chat as ChatType } from "@/types/chat";
import { WhatsappStatus } from "@/types/whatsapp";
import { Head } from "@inertiajs/react";

export default function Index({
  chats,
  status,
  archivedMode,
}: {
  chats: ChatType[];
  status: WhatsappStatus;
  archivedMode?: boolean;
}) {
  return (
    <>
      <Head title="Conversas" />
      <ChatWorkspace chats={chats} status={status} archivedMode={archivedMode} />
    </>
  );
}
